import React from 'react';
import { isEmpty } from 'lodash';
// moment-timezone, not moment: the reschedule date is rendered in the event's zone.
import moment from 'moment-timezone';

import ACButtonV2 from '../ac-react-components/ACButtonV2';

const STATUS_CLASSNAMES = {
    enquired: 'black',
    drafted: 'gray',
    quoted: 'orange',
    requested: 'purple',
    tentative: 'acRed',
    booked: 'acBlue',
    confirmed: 'acGreen',
    completed: 'green',
    declined: 'darkGray',
    reschedulerequested: 'orange',
    postponed: 'darkGray',
};

// A reschedule request carries its own sub-status on the HQ event, so the pill spells
// out what was asked for rather than just "Reschedule Requested".
const getRescheduleText = (hq = {}) => {
    switch (hq.rescheduleRequestStatus) {
        case 8: // booked
            if (hq.rescheduleRequestDate) {
                const newDate = moment(hq.rescheduleRequestDate)
                    .tz(hq.timezone || 'UTC')
                    .format('DD MMM YYYY z');
                return `Reschedule Requested: ${newDate}`;
            }
            return 'Reschedule Requested - Invalid Date';
        case 13: // postponed
        default:
            return 'Reschedule Requested - Postponed';
    }
};

/**
 * The HQ lifecycle pill (enquired / booked / confirmed / …). Read-only — HQ owns this
 * status and pushes changes down; nothing in the planner sets it.
 *
 * Shared by the legacy booking row and the occasion header. It is deliberately NOT
 * rendered on an occasion's component bookings: a component's `hq` is a snapshot taken
 * when the component was built, and HQ status updates only ever write the root
 * `hq.status` — so a component's copy goes stale the moment the event moves on.
 */
const ACBookingStatusPill = ({ hq = {} }) => {
    const status = hq.status;
    if (isEmpty(status)) return null;

    const statusText = status === 'reschedulerequested' ? getRescheduleText(hq) : status;

    return (
        <ACButtonV2
            className={STATUS_CLASSNAMES[status]}
            text={statusText}
            style={{
                textTransform: 'capitalize',
                fontFamily: 'gilroy-regular',
            }}
        />
    );
};

export default ACBookingStatusPill;
